import { createFeatureSelector, createSelector } from '@ngrx/store';
import { GET_SEATMAPS_STORE_NAME, GetSeatmapsState } from './get-seatmaps.state';

/** Select GetSeatmaps State */
export const selectGetSeatmapsState = createFeatureSelector<GetSeatmapsState>(GET_SEATMAPS_STORE_NAME);

/** Select GetSeatmaps isPending status */
export const selectGetSeatmapsIsPendingStatus = createSelector(selectGetSeatmapsState, (state) => !!state.isPending);

/** Select GetSeatmaps isFailure status */
export const selectGetSeatmapsIsFailureStatus = createSelector(selectGetSeatmapsState, (state) => !!state.isFailure);
